import { DealType } from "@/enums/dealType";
import { CacheTag } from "@/enums/cacheTags";

export function getCacheTagByDealType(dealType: DealType): CacheTag {
  switch (dealType) {
    case DealType.BUY:
      return CacheTag.PROPERTY_COLLECTION_BUY;
    case DealType.RENT:
      return CacheTag.PROPERTY_COLLECTION_RENT;
    case DealType.PRIMARY:
      return CacheTag.PROPERTY_COLLECTION_DEVELOPER;
    default:
      return CacheTag.PROPERTY_COLLECTION;
  }
}
